import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../../../environments/environment';

@Component({
	selector: 'app-recommendation-modal',
	templateUrl: './recommendation-modal.component.html',
	styleUrls: ['./recommendation-modal.component.scss']
})
export class RecommendationModalComponent implements OnInit {
	// eslint-disable-next-line @angular-eslint/no-input-rename
	@Input('component') componentData;
	@Input() modalElement;
	@Output() output = new EventEmitter<any>();
	@ViewChild('movingElement', { static: true }) movingElement: ElementRef;
	WrapperHeight = window.innerHeight * 0.9 - 140;
	backup;

	elementHeight;
	elementWidth;
	sampleText = 'Sample Text';
	testImage;
	safeImages: Array<any> = [];
	safeBackground;

	// Error suppressing
	top_offsetFocus;
	left_offsetFocus;
	heightFocus;
	widthFocus;
	webComponentDomain = environment.webComponentUrl;

	constructor(private sanitation: DomSanitizer) {}

	ngOnInit() {
		this.safeBackground = this.componentData.config.background['background-image']
			? this.sanitation.bypassSecurityTrustStyle(`url(${this.componentData.config.background['background-image']}) 0 0 no-repeat`)
			: this.componentData.config.background['background-color'];

		for (var i = 0; i < this.componentData.config.items.length; i++) {
			this.safeImages.push(this.sanitation.bypassSecurityTrustStyle('url(' + this.componentData.config.items[i].image + ')'));
		}

		this.elementHeight = this.componentData.config.item_height;
		this.elementWidth = Math.floor(
			this.componentData.config.item_width / parseInt(this.componentData.config.cols) - this.componentData.config.spacing * 2
		);

		this.backup = {
			item_height: this.componentData.config.items[this.modalElement].height,
			item_width: this.componentData.config.items[this.modalElement].width,
			left_offset: this.componentData.config.items[this.modalElement].left,
			top_offset: this.componentData.config.items[this.modalElement].top,
			text_alignment: this.componentData.config.items[this.modalElement].text.text_alignment
		};
	}

	updatePosition(event, index) {
		this.componentData.config.items[index].left = event.left;
		this.componentData.config.items[index].top = event.top;
	}

	updateResize(event, placement, index) {
		switch (placement) {
			case 'top':
				this.componentData.config.items[index].top = event.top;
				this.componentData.config.items[index].height = event.height;
				break;
			case 'bottom':
				this.componentData.config.items[index].height = event.height;
				break;
			case 'left':
				this.componentData.config.items[index].width = event.width;
				this.componentData.config.items[index].left = event.left;
				break;
			case 'right':
				this.componentData.config.items[index].width = event.width;
				break;
		}
	}

	update() {
		this.output.emit({ method: 'update', data: this.componentData });
	}

	cancel() {
		this.componentData.config.items[this.modalElement].height = this.backup.item_height;
		this.componentData.config.items[this.modalElement].width = this.backup.item_width;
		this.componentData.config.items[this.modalElement].left = this.backup.left_offset;
		this.componentData.config.items[this.modalElement].top = this.backup.top_offset;
		this.componentData.config.items[this.modalElement].text.text_alignment = this.backup.text_alignment;
		this.output.emit({ method: 'cancel', data: this.componentData });
	}
}
